import { Sort } from './sort';

export class Pageable {
    sort: Sort;
    offset: number;
    pageNumber: number;
    pageSize: number;
    unpaged: boolean;
    paged: boolean;

    static readonly DEFAULT_PAGE_SIZE = 10;
    static readonly FIRST_PAGE_NUMBER = 0;

    constructor() {
        this.pageSize = Pageable.DEFAULT_PAGE_SIZE;
        this.pageNumber = Pageable.FIRST_PAGE_NUMBER;
    }
}
